
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M11.6121 14.4546C12.9677 14.4546 14.0667 13.3556 14.0667 12C14.0667 10.6444 12.9677 9.54547 11.6121 9.54547C10.2565 9.54547 9.15759 10.6444 9.15759 12C9.15759 13.3556 10.2565 14.4546 11.6121 14.4546Z"></path><path d="M18.1576 12C18.1567 11.5287 18.1051 11.0588 18.0038 10.5985L20.2244 8.91709L18.588 6.08291L16.0165 7.16782C15.3201 6.52939 14.4935 6.04955 13.5938 5.76136L13.2485 3H9.97582L9.63055 5.76136C8.73083 6.04955 7.90429 6.52939 7.20791 7.16782L4.63636 6.08291L3 8.91709L5.22055 10.5985C5.0155 11.5216 5.0155 12.4784 5.22055 13.4015L3 15.0829L4.63636 17.9171L7.20791 16.8322C7.90429 17.4706 8.73083 17.9505 9.63055 18.2386L9.97582 21H13.2485L13.5938 18.2386C14.4935 17.9505 15.3201 17.4706 16.0165 16.8322L18.588 17.9171L20.2244 15.0829L18.0038 13.4015C18.1051 12.9412 18.1567 12.4713 18.1576 12V12Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiSettings",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
